//
//  localStorage.ts
//
//  isana.net,inc. Proprietary and Confidential
//

class LocalStorageManager {
  constructor() {}
  CODE_VERIFIER = "codeVerifier";
  FITINSIGHT_UNIQUE_ID = "fitinsightUniqueId";
  GROUP = "belongingGroup";
  USER_ID = "userId";
  DATE_RANGE_START = "dateRangeStart";
  DATE_RANGE_END = "dateRangeEnd";
  SELECTED_CSV_SUMMARY_ITEMS = "selectedCsvSummaryItems";
  SELECTED_GHA_CSV_SUMMARY_ITEMS = "selectedGhaCsvSummaryItems";

  // MARK: - LocalStorage
  private getLocalStorage(
    key: LocalStorageManager.LocalStorageKey
  ): string | null {
    return localStorage.getItem(key);
  }

  private setLocalStorage(
    key: LocalStorageManager.LocalStorageKey,
    value: string
  ): void {
    localStorage.setItem(key, value);
  }

  private removeLocalStorage(key: LocalStorageManager.LocalStorageKey): void {
    localStorage.removeItem(key);
  }

  // MARK: getter
  public getCodeVerifier(): string | null {
    return this.getLocalStorage(this.CODE_VERIFIER);
  }

  public getFitinsightUniqueId(): string | null {
    return this.getLocalStorage(this.FITINSIGHT_UNIQUE_ID);
  }

  public getGroup(): string | null {
    return this.getLocalStorage(this.GROUP);
  }

  public getUserId(): string | null {
    return this.getLocalStorage(this.USER_ID);
  }
  // MARK: setter
  public setCodeVerifier(value: string): void {
    this.setLocalStorage(this.CODE_VERIFIER, value);
  }

  public setFitinsightUniqueId(value: string): void {
    this.setLocalStorage(this.FITINSIGHT_UNIQUE_ID, value);
  }

  public setGroup(value: string): void {
    this.setLocalStorage(this.GROUP, value);
  }

  public setUserId(value: string): void {
    this.setLocalStorage(this.USER_ID, value);
  }

  // MARK: remove
  public removeCodeVerifier(): void {
    this.removeLocalStorage(this.CODE_VERIFIER);
  }

  public removeUserId(): void {
    this.removeLocalStorage(this.USER_ID);
  }

  // アプリが保存する全キーを削除する（ログアウト時に呼ぶ）
  public clearAll(): void {
    const keys: LocalStorageManager.LocalStorageKey[] = [
      this.CODE_VERIFIER,
      this.FITINSIGHT_UNIQUE_ID,
      this.GROUP,
      this.USER_ID,
      this.DATE_RANGE_START,
      this.DATE_RANGE_END,
      this.SELECTED_CSV_SUMMARY_ITEMS,
      this.SELECTED_GHA_CSV_SUMMARY_ITEMS,
    ];
    keys.forEach((key) => this.removeLocalStorage(key));
  }
}

export const localStorageManager = new LocalStorageManager();

namespace LocalStorageManager {
  export type LocalStorageKey =
    | typeof localStorageManager.CODE_VERIFIER
    | typeof localStorageManager.FITINSIGHT_UNIQUE_ID
    | typeof localStorageManager.GROUP
    | typeof localStorageManager.USER_ID
    | typeof localStorageManager.DATE_RANGE_START
    | typeof localStorageManager.DATE_RANGE_END
    | typeof localStorageManager.SELECTED_CSV_SUMMARY_ITEMS
    | typeof localStorageManager.SELECTED_GHA_CSV_SUMMARY_ITEMS;
}
